import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../../utils";

export const updateDistrict = createAsyncThunk('updateDistrict', async (data) => {

    try {
        const res = await axios({

            method: 'PUT',
            url: process.env.REACT_APP_API_URL + 'district',
            data: {
                "district_id": data?.values?.id,
                "state_id": data?.values?.state,
                "district_name": data?.values?.districtName,
                "status": data?.values?.status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})